import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { payWithEnterpriseCard } from '../../../../services/enterprisecard/actions';

import { LoadingComponent } from '../../../loading/LoadingComponent';

const EnterpriseCard = ({ userInfo, partnerId, order, payWithEnterpriseCard, fetching, error }) => {
    useEffect(() => {
        if (order && order.orderState === 'created') {
            payWithEnterpriseCard(userInfo, partnerId, order.id);
        }
    }, [order]);

    return (
        <div className="enterprise-card-payment-processing">
            {fetching && <LoadingComponent />}

            {!fetching && error ? <p className="error">{error}</p> : <p></p>}
        </div>
    );
};

EnterpriseCard.propTypes = {
    userInfo: PropTypes.object,
    partnerId: PropTypes.number,
    order: PropTypes.object
};

const mapStateToProps = state => {
    return {
        fetching: state.enterprisecard.fetching,
        error: state.enterprisecard.error
    };
};

const mapDispatchToProps = {
    payWithEnterpriseCard
};

export default connect(mapStateToProps, mapDispatchToProps)(EnterpriseCard);



// WEBPACK FOOTER //
// ./src/components/funnel/payment-step/payment-methods/EnterpriseCard.js